
* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

.vulnerable-servers-number {
  font-weight: 500;
  color: var(--black-layout-700-primary);

  width: 100%;
  height: 100%;
}

.clickable:hover {
  color: var(--blue-layout-400-primary);
  cursor: pointer;
}

.flex-center {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
